import { types as layoutTypes } from './layout';
import svc from 'svc';



export const types = {
	SET_STATE: 'BUSINESSPARTNERS/SET_STATE',
	SET_ACTIVITY: 'BUSINESSPARTNERS/SET_ACTIVITY',
	RESET_CONTACT: 'BUSINESSPARTNERS/RESET_CONTACT',
	RESET_ADDRESS: 'BUSINESSPARTNERS/RESET_ADDRESS',
	RESET_ALL: 'BUSINESSPARTNERS/RESET_ALL',
	RESET_ACTIVITY: 'BUSINESSPARTNERS/RESET_ACTIVITY',
};

export const initialState = {
	blockRouting: false,
	tab: 'act',
	sidePanel: null,
	tabExtras: 'contact',
	tabMain: 'general',
	pending: true,
	resized: false,
	savingBP: false,
	savingAddress: false,
	savingContact: false,
	savingActivity: false,
	loadingAddress: false,
	loadingContact: false,
	loadingActivity: false,
	bp: {
		Name: '',
		Code: 'NEW',
		Type: 'C',
		GroupName: 'CUSTOMERS',
		SlpCode: '-1',
		Phone1: '',
		Phone2: '',
		Cell: '',
		Fax: '',
		Email: '',
		Website: '',
		OrdersBal: '',
		ShipType: '1',
		DefaultContactName: '',
		DefaultShipTo: '',
		DefaultBillTo: '',
		Notes: '',
		Valid: 'Y',
		ValidFor: '',
		FrozenFor: '',
		ValidFrom: getDate(),
		FrozenFrom: '',
		ValidTo: '',
		FrozenTo: '',
		ValidRemarks: '',
		FrozenRemarks: '',

		// Payment Terms
		PaymentTermsCode: '11',
		PriceListNum: '',

		// Properties
		Property1: 'N',
		Property2: 'N',
		Property3: 'N',
		Property4: 'N',
		Property5: 'N',
		Property6: 'N',
		Property7: 'N',
		Property8: 'N',
		Property9: 'N',
		Property10: 'N',
		Property11: 'N',
		Property12: 'N',
		Property13: 'N',
		Property14: 'N',
		Property15: 'N',
		Property16: 'N',
		Property17: 'N',
		Property18: 'N',
		Property19: 'N',
		Property20: 'N',
		Property21: 'N',
		Property22: 'N',
		Property23: 'N',
		Property24: 'N',
		Property25: 'N',
		Property26: 'N',
		Property27: 'N',
		Property28: 'N',
		Property29: 'N',
		Property30: 'N',
		Property31: 'N',
		Property32: 'N',
		Property33: 'N',
		Property34: 'N',
		Property35: 'N',
		Property36: 'N',
		Property37: 'N',
		Property38: 'N',
		Property39: 'N',
		Property40: 'N',
		Property41: 'N',
		Property42: 'N',
		Property43: 'N',
		Property44: 'N',
		Property45: 'N',
		Property46: 'N',
		Property47: 'N',
		Property48: 'N',
		Property49: 'N',
		Property50: 'N',
		Property51: 'N',
		Property52: 'N',
		Property53: 'N',
		Property54: 'N',
		Property55: 'N',
		Property56: 'N',
		Property57: 'N',
		Property58: 'N',
		Property59: 'N',
		Property60: 'N',
		Property61: 'N',
		Property62: 'N',
		Property63: 'N',
		Property64: 'N',

		// Remarks
		FreeText: '',

		// Lead Generator
		U_PURCHASEACCT: '',
		U_AltSalesEmployee: '',
		U_LeadGenerator: '',
		U_2003SALES: '0',
		U_2004SALES: '0',
		U_2005SALES: '0',
		U_2006SALES: '0',
		U_2007SALES: '0',
		U_2008SALE: '0',
		U_2009SALES: '0',
		U_CATALOG: '',
		U_MCDistrict: '',
		U_PRX_WbAct: '',
		U_BD_Erst: 'Y',
		U_BD_Datev: '',
		U_TimeZone: '',
		U_VENDORACCT: '',
		U_BPPRIORITY: '',
		U_LANGUAGE: '',
		U_CUSTOMDATE: '',
		U_CUSTOMINFO: '',
		U_SALESPRODINFO: '',
		U_FLAGSINFO: '',
		U_DEALERSUPPINFO: '',
		U_FORMSINFO: '',
		U_SERVDEPTINFO: '',
		U_WINSHIELDDATE: '',
		U_WINSHIELDINFO: '',
		U_NEWUNITS: '',
		U_USEDUNITS: '',
		U_FLAGDATE: '',
		U_DEALERSUPPDATE: '',
		U_FORMSDATE: '',
		U_SERVICEDEPTDATE: '',
		U_SALESPRODDATE: '',
		U_CUSTDATE: '',
		U_DEALERGROUP: '',
		U_DpmtRequired: 'Y', //needs Y/N Dropdown.
		U_UPSNUMBER: '',
		U_SalesYTD: '0',
		U_CPOV: 'Y',
		U_Units: '',
		U_EMAIL: 'Y',
		U_NBS_Source: '',
		U_NBS_Campaign: '',
		U_NBS_NumEmploy: '0',
		U_NBS_SalesRevenue: '0',
		U_NBS_IndustryCode: '',
		U_NBS_Description: '',
		U_NBS_Type: '',
		U_NBS_Interest: '',
		U_NBS_LMUDF1: '',
		U_NBS_LMUDF2: '',
		U_NBS_LMUDF3: '',
		U_NBS_LMUDF4: '',
		U_NBS_LMUDF5: '',
		//U_NBS_LMCODE: '',
		U_DefaultPayment: '',

		// Accounting
		FatherCard: '',
		FatherType: '',
		AccountsReceivable: '',
		PaymentAdvances: '',
		PlanningGroup: '',
		Affiliate: 'N',
		TaxStatus: 'Y',

		// Options
		showAllProperties: false,
	},
	paymentMethods: [],
	addresses: { billing: [], shipping: [] },
	contacts: [],
	addressVis: [],
	contactVis: [],
	activities: [],
	newContact: {
		ID: '',
		First: '',
		Middle: '',
		Last: '',
		Title: '',
		Position: '',
		Phone: '',
		Phone2: '',
		Cell: '',
		Fax: '',
		Email: '',
		Pager: '',
		Remarks1: '',
		Remarks2: '',
		Password: '',
		U_TWBS_CWCnType: 'None',
		U_TWBS_CWRptDel: 'None',
		U_PromoDate: '',
		PromoDateOriginal: '',
		U_PromoUpdatedBy: '',
		PromoUpdatedByOriginal: '',
		U_PromoStatus: 'Unsubscribed',
		PromoStatusOriginal: 'Unsubscribed',
		U_PRX_SID: '0',
		U_PRX_PWD: '',
		U_PromotionEmail: '',
		Active: 'Y',
		SetDefault: false,
		isNew: false,
	},
	activeContact: null,
	newAddress: {
		ID: '',
		Street: '',
		City: '',
		State: '',
		Zip: '',
		County: '',
		Country: 'US',
		Type: 'B',
		U_PRX_SID: '',
		TaxCode: 'UPDATE',
		isNew: false,
	},
	activeAddress: null,
	newActivity: {
		Class: 'C',
		CardCode: '',
		TypeCode: '-1',
		SubjectCode: '',
		Notes: '',
		Remarks: '',
		Priority: '1',
		ContactName: '',
		Phone: '',
		HandledByUserID: '1',
		StartDate: getDate(),
		StartTime: '',
		EndDueDate: getDate(),
		EndTime: '',
		StatusCode: '-2',
		SlpCode: '-1',
		Room: '',
		Street: '',
		City: '',
		State: '',
		Country: 'US',
		Closed: 'N',
		Inactive: 'N',
		Tentative: 'N',
		isNew: true,
		OrigClosed: 'N',
		U_NotifyUser: 'N',
		docLink: 'N',
		U_AssignedBy: '',
		AssignedByName: '',
		U_PRIORITYTOGGLE: 'N',
	},
};


export default ( state = initialState, action ) => {
	switch (action.type) {
		case types.SET_STATE:
			return { ...state, ...action.data };
		case types.SET_ACTIVITY:
			return { ...state, newActivity: {...state.newActivity, ...action.data} };
		case types.RESET_CONTACT:
			return { ...state, activeContact: null, newContact: { ...initialState.newContact, isNew: action.isNew } };
		case types.RESET_ADDRESS:
			return { ...state, activeAddress: null, newAddress: { ...initialState.newAddress, isNew: action.isNew } };
		case types.RESET_ACTIVITY:
			return {
				...state,
				newActivity: { ...initialState.newActivity, isNew: action.isNew, CardCode: action.cardCode },
			};
		case types.RESET_ALL:
			return { ...initialState };

		default:
			return state
	}
}

export const actions = {
	setState: ( data ) => ({ type: types.SET_STATE, data }),
	setActivity: ( data ) => ({ type: types.SET_ACTIVITY, data }),
	resetContactForm: ( isNew = false ) => ({ type: types.RESET_CONTACT, isNew }),
	resetAddressForm: ( isNew = false ) => ({ type: types.RESET_ADDRESS, isNew }),
	resetActivityForm: ( isNew = false, cardCode = '' ) => ({ type: types.RESET_ACTIVITY, isNew, cardCode }),
	resetAll: () => ({ type: types.RESET_ALL }),

	getAddresses: () => {
		return ( dispatch, getState ) => {
			let state = getState().businessPartners;
			if ( !state.bp.Code ) {
				dispatch( { type: layoutTypes.NOTIFY, text: `Can't load addresses without CardCode.` } );
				return false;
			}
			svc.send( 'bp', { method: 'getAddresses', cardCode: state.bp.Code } ).then( res => {
				dispatch( actions.setState( { addresses: res.payload.data } ) );
			} ).catch( err => {
				dispatch( { type: layoutTypes.NOTIFY, text: 'Error retrieving BP addresses.' } );
			} );
		};
	},

	getContacts: () => {
		return ( dispatch, getState ) => {
			let state = getState().businessPartners;
			if ( !state.bp.Code ) {
				dispatch( { type: layoutTypes.NOTIFY, text: `Can't load contacts without CardCode.` } );
				return false;
			}
			svc.send( 'bp', { method: 'getContacts', cardCode: state.bp.Code } ).then( res => {
				dispatch( actions.setState( { contacts: res.payload.data } ) );
			} ).catch( err => {
				dispatch( { type: layoutTypes.NOTIFY, text: 'Error retrieving BP contacts.' } );
			} );
		};
	},
};


function getDate( addDays = 0 ) {
	let now = new Date();
	let adjusted = new Date( now );
	adjusted.setDate( adjusted.getDate() + addDays );

	let dd = adjusted.getDate();
	let mm = adjusted.getMonth() + 1; //January is 0!
	let yyyy = adjusted.getFullYear();

	if ( dd < 10 ) {
		dd = '0' + dd;
	}
	if ( mm < 10 ) {
		mm = '0' + mm;
	}

	return `${yyyy}-${mm}-${dd}`;
}